import PortalBody from './PortalBody';

export default PortalBody;
